// src/state/customers/remoteLocation/types.ts
var SET_REMOTE_LOCATION_CUSTOMERS = "SET_REMOTE_LOCATION_CUSTOMERS";
var SET_REMOTE_LOCATION_CUSTOMERS_WS = "SET_REMOTE_LOCATION_CUSTOMERS_WS";

export { SET_REMOTE_LOCATION_CUSTOMERS, SET_REMOTE_LOCATION_CUSTOMERS_WS };
